import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
      DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
  import * as Leaflet from "leaflet";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ScuolaDTO } from "src/app/models/scuola.model";
import { environment } from "src/environments/environment";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { PraticheService } from "src/app/services/pratiche.service";
import { PraticaScuola } from "src/app/models/pratica.scuola.model";
import { Centrale } from "src/app/models/centrale.models";
import { ComuneDTO } from "src/app/models/comune.model";
import { DettaglioPraticaScuolaDTO } from "src/app/models/dettaglioPratica.scuola.model";
import { Pratica } from "src/app/models/pratica.model";
import { ModificaPosizioneScuola } from "../../../shared/modifica-posizione-scuola/modifica-posizione-scuola.component";
import { DialogRichiediAggiornamentoCentrale } from "src/app/pages/pratiche/scuola/bando2/aggiornamento-centrale-bando2.component";
import { Tipologia } from "src/app/models/tipologia.model";

interface TipoBackup {
    id: number;
    codice: string;
  }
  

@Component({
  selector: "component-informazioni-fase3-bando2",
  templateUrl: "./dialog-inserisci-informazioni-pratica.component.html",
  styleUrls: ["../fase3.bando2.component.css"],
})
export class DialogInformazioniFase3Bando2 implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pratica: Pratica;
  public praticaFromFirestore: PraticaFlowdy2_Firestore;
  selectedFile: File = null;
  isFileUploaded: boolean = false;
  isLoadingResults: boolean = false;
  protected pagineInserisciInformazioni: MenuItem[];
  protected activeIndex: number = 0;

  protected reteAccessoForm: FormGroup;
  protected ubicazioneRouterForm: FormGroup;
  protected identificazioneFibraFormB: FormGroup;
  protected identificazioneFibraFormC: FormGroup;
  protected localizzazioniForm: FormGroup;
  protected dettagliForm: FormGroup;
  private scuola: ScuolaDTO;
  private isTipoB:Boolean=false;
  private isTipoAC:Boolean=false;
  private isTipoBFromC:Boolean = false;
  private isTipoD:Boolean = false;
  private isColocata:Boolean = false;
  
  protected ref: DynamicDialogRef;
  private collection_pratiche_scuola:string = environment.firebase.collection_pratiche;

  private tipiBackup:TipoBackup[];

  protected tipologie:Tipologia[]   = [];
  protected diritti:Tipologia[]     = [];
  protected proprietari:Tipologia[] = [];
  protected tipologieCavi:Tipologia[]   = [];
  protected hasBackup: boolean = false;

  protected pratiche:PraticaFlowdy2_Firestore[] ;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _formBuilder: FormBuilder,
    private praticheScuolaService: PraticheService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private firestoreService:AngularFirestore
  ) {
    this.tipiBackup = [
      { id: 1, codice: 'FO' },
      { id: 2, codice: 'LTE' },
      { id: 3, codice: 'NESSUNO' }
    ];
    this.inizializzazioneTipologie();
  }

  inizializzazioneTipologie(){
    let tipologiaScavo:Tipologia = new Tipologia();
    let tipologiaFibra:Tipologia = new Tipologia();
    let tipologiaMinitubo:Tipologia = new Tipologia();

    tipologiaScavo.codice = "Scavo";
    tipologiaFibra.codice = "Fibra";
    tipologiaMinitubo.codice = "Minitubo";
    this.tipologie.push(tipologiaFibra);
    this.tipologie.push(tipologiaScavo);
    this.tipologie.push(tipologiaMinitubo);
    let tipologiaCavo12:Tipologia = new Tipologia();
    let tipologiaCavo24:Tipologia = new Tipologia();
    let tipologiaCavo48:Tipologia = new Tipologia();
    tipologiaCavo12.codice = "Cavo 12 Fibre";
    tipologiaCavo24.codice = "Cavo 24 Fibre";
    tipologiaCavo48.codice = "Cavo 48 Fibre";
    this.tipologieCavi.push(tipologiaCavo12);
    this.tipologieCavi.push(tipologiaCavo24);
    this.tipologieCavi.push(tipologiaCavo48);

    let dirittoProprieta:Tipologia = new Tipologia();
    let dirittoIRU:Tipologia = new Tipologia();
    let dirittoSubIRU:Tipologia = new Tipologia();
    
    dirittoProprieta.codice = "Proprietà";
    dirittoIRU.codice = "IRU";
    dirittoSubIRU.codice = "SubIRU";
    this.diritti.push(dirittoProprieta);
    this.diritti.push(dirittoIRU);
    this.diritti.push(dirittoSubIRU);

    let proprietarioTIM:Tipologia = new Tipologia();
    let proprietarioINFRATEL:Tipologia = new Tipologia();
    let proprietarioFastweb:Tipologia = new Tipologia();
    proprietarioTIM.codice = "TIM";
    proprietarioINFRATEL.codice = "Infratel";
    proprietarioFastweb.codice = "Fastweb";
    
    this.proprietari.push(proprietarioTIM);
    this.proprietari.push(proprietarioINFRATEL);
    this.proprietari.push(proprietarioFastweb);
  }

  ngOnInit(): void {
    this.pratica                = this.config.data.pratica;
    this.praticaFromFirestore   = this.config.data.praticaFromFirestore;
    this.scuola                 = this.config.data.scuola;
    this.pratiche               = this.config.data.pratiche;
  // this.logger.info(JSON.stringify(this.praticaFromFirestore.tipoSedeEffettiva + " "+ this.praticaFromFirestore.tipoSede));
    if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('C') || this.praticaFromFirestore.tipoSedeEffettiva.endsWith('A')){
      this.isTipoAC = true;
      this.logger.info('[FASE 3 BANDO 2] INFO: SI TRATTA DI UNA PRATICA A/C');

    }else if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('B') || this.praticaFromFirestore.tipoSedeEffettiva.endsWith('B*')){
      //this.logger.info('SI TRATTA DI UNA PRATICA B O B*');
      if(this.praticaFromFirestore.tipoSede.endsWith('C')){
        this.isTipoB = true;
        this.isTipoBFromC = true;
        this.logger.info('[FASE 3 BANDO 2] INFO: SI TRATTA DI UNA PRATICA B FROM C');
      }else{
        this.isTipoB = true;
        this.logger.info('[FASE 3 BANDO 2] INFO: SI TRATTA DI UNA PRATICA B');
      }
    }else if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('D')){
      this.logger.info('[FASE 3 BANDO 2] INFO: SI TRATTA DI UNA PRATICA A/C');
      this.isTipoD = true;
    }
    
    /* if(this.isTipoAC){
      this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA AC ");
    }else if(this.isTipoB){
      this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA B ");
      if(this.isTipoBFromC){
        this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA B FROM C ");
      }
    
    }else if(this.isTipoD){
      this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA D");

    } */

    this.isColocata = this.config.data.isColocata;
    //this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA COLOCATA "+ this.isColocata);
    this.hasBackup = this.praticaFromFirestore.backup?true:false;
    
    this.inizializzaFormGroups();
    this.inizializzaSteps();
  }
 /*  getPraticaPrincipaleDiUnaColocata(cuiPrincipale: string): PraticaFlowdy2_Firestore {
    return this.pratiche.find(pratica => pratica.cui === cuiPrincipale);
  }
  getPraticheColocateDiUnaPrincipale(cuiPrincipale: string): PraticaFlowdy2_Firestore[] {
    return this.pratiche.filter(pratica => pratica.colocataScuolaPrincipale === cuiPrincipale);
  }

  checkCodiceInvioUgualeColocate(pratica:PraticaFlowdy2_Firestore):boolean{
    let sameCodiceInvio = true;
    if(pratica.colocataRuolo==='SECONDARIA'){
      let principale:PraticaFlowdy2_Firestore = this.getPraticaPrincipaleDiUnaColocata(pratica.colocataScuolaPrincipale);
      if(principale){
        //// this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo + " -> "+ pratica.codiceInvio + " vs "+ principale.codiceInvio);

        if(principale.codiceInvio && pratica.codiceInvio){
          if(principale && principale.codiceInvio !== pratica.codiceInvio){
            sameCodiceInvio = false;
          }
        }else{
          sameCodiceInvio = false;
        }
      }else{
        this.logger.info("--> checkCodiceInvioUgualeColocate: LA PRATICA COLOCATA "+pratica.cui + " MANCA DELLA SUA PRINCIPALE");

        sameCodiceInvio = false;
      }
    }else if(pratica.colocataRuolo==='PRINCIPALE' ){
      let secondarie:PraticaFlowdy2_Firestore[] = this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      secondarie.forEach(secondaria => {
        if(secondaria.codiceInvio!==pratica.codiceInvio){
          sameCodiceInvio = false;
        }
      });
    }

    return sameCodiceInvio;
  }
  checkIfColocata(pratica:PraticaFlowdy2_Firestore):boolean{
     if(!pratica.colocata){
      this.logger.info("checkIfColocata ---> "+ pratica.cui + " NON COLOCATA ");

      return false;
    }else{
      if(pratica.colocataRuolo === 'PRINCIPALE'){
        if(this.checkCodiceInvioUgualeColocate(pratica)){
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " PRINCIPALE STESSO CODICE INVIO - COLOCATA");
          return true;
        }else{
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " PRINCIPALE DIVERSO CODICE INVIO - NON COLOCATA");
          return false;
        }
        //return true;
      
      }else if(pratica.colocataRuolo === 'SECONDARIA'){
        if(this.checkCodiceInvioUgualeColocate(pratica)){
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA STESSO CODICE INVIO - COLOCATA");
          return true;
        }else{
          this.logger.info("checkIfColocata ---> "+ pratica.cui + " SECONDARIA DIVERSO CODICE INVIO - NON COLOCATA");
          return false;
        }
      }
    }
    return false; 
  } */
  
  getTipoBackup(tipologia:String):number{
    switch (tipologia) {
      case "FO":
        return 0;
      case "LTE":
        return 1;
      case "NESSUNO":
        return 2;
      default:
        return null;
    }
  }
  getTipologia(tipologia:String):number{
    switch (tipologia) {
      case "SCAVO":
        return 1;
      case "Scavo":
        return 1;
      case "SCAVO":
        return 1;
      case "FIBRA":
        return 0;
      case "Fibra":
        return 0;
      case "MINITUBO":
        return 2;
      case "Minitubo":
        return 2;
      default:
        return null;
    }
  }
  getTipologiaCavo(tipologia:String):number{
    switch (tipologia) {
      case "12 fibre TOL6D 12 1(12 SM) T/M":
        return 0;
      case "24 fibre TOL6D 24 2(12 SM) T/M":
        return 1;
      case "48 fibre TOL6D 48 4(12 SM) T/M":
        return 2;
      default:
        return null;
    }
  }

  getCodiceTipologiaCavo(tipologia:String):string{

    switch (tipologia) {
      case "Cavo 12 Fibre":
        return "12 fibre TOL6D 12 1(12 SM) T/M";
      case "Cavo 24 Fibre":
        return "24 fibre TOL6D 24 2(12 SM) T/M";
      case "Cavo 48 Fibre":
        return "48 fibre TOL6D 48 4(12 SM) T/M";
      default:
        return null;
    }
  }
  getDiritto (diritto:String):number{
    switch (diritto) {
      case "Proprietà":
        return 0;
      case "IRU":
        return 1;
      default:
        return 2;
    }
  }
  getProprietario(proprietario:String):number{
    switch (proprietario) {
      case "TIM":
        return 0;
        case "INFRATEL":
          return 1;
      default:
        return 2;
    }
  }
  inizializzaFormGroups() {
   /*  this.reteAccessoForm = this._formBuilder.group({
      tipologia: [this.scuola.tipologia, [Validators.required]],
      diritto: [this.scuola.proprietario, [Validators.required]],
      proprietario: [this.scuola.proprietario, [Validators.required]],
      numeroAccessPoints: [
        this.scuola.numeroAccessPoint,
        [Validators.required],
      ],
    }); */
   
    if(!this.isTipoAC){
      //this.logger.info("inizializzaFormGroups DI UNA PRATICA B "+ this.pratica.tipoBSharp + " con tipo bu "+ this.scuola.tipoBackup);
      this.logger.info("ANNO ATTIVAZIONE PRATICA "+ this.pratica.annoAttivazione);
      this.dettagliForm = this._formBuilder.group({
        annoAttivazione:      [ this.pratica.annoAttivazione, [Validators.required]],
        hostnameCPE:        [ this.scuola.hostnameCpe, [Validators.required]],
        ipAddress:          [ this.scuola.ipAddress, !this.isTipoD && !this.isTipoB?[Validators.required]:null],
        localeTecnico:      [ this.scuola.localeTecnicoNome, [Validators.required]],
        piano:              [ this.scuola.localeTecnicoPiano, [Validators.required]],
        stanza:             [ this.scuola.localeTecnicoStanza, [Validators.required]],
        redattore:          [ this.pratica.datiFase3.redattore, [Validators.required]],
        verificatore:       [ this.pratica.datiFase3.verificatore, [Validators.required]],
        lunghezza:          [ this.scuola.lunghezza, !this.isTipoD && !this.isTipoB?[Validators.required]:null],
        tipologia:          [this.scuola.tipologia?this.tipologie[this.getTipologia(this.scuola.tipologia)]:null, this.isTipoB ? [Validators.required] : null],
        diritto:            [this.scuola.diritto?this.diritti[this.getDiritto(this.scuola.diritto)]:null, this.isTipoB ? [Validators.required] : null],
        proprietario:       [this.scuola.proprietario?this.proprietari[this.getProprietario(this.scuola.proprietario)]:null, this.isTipoB ? [Validators.required] : null],
        lunghezzaTratta2:   [this.scuola.lunghezzaTratta2?this.scuola.lunghezzaTratta2:null],
        tipologiaTratta2:       [this.scuola.tipologiaTratta2?this.tipologieCavi[this.getTipologiaCavo(this.scuola.tipologiaTratta2)]:null],
        dirittoTratta2:         [this.scuola.dirittoTratta2?this.diritti[this.getDiritto(this.scuola.dirittoTratta2)]:null],
        proprietarioTratta2:    [this.scuola.proprietarioTratta2?this.proprietari[this.getProprietario(this.scuola.proprietarioTratta2.toUpperCase())]:null],
      });
      this.identificazioneFibraFormB = this._formBuilder.group({
        clliSedeA:                      [ this.scuola.clliSedeA, [Validators.required]],
        tipologiaSedeA:                 [ this.scuola.tipologiaSedeA, [Validators.required]],
        descrizioneSedeA:               [ this.scuola.descrizioneSedeA, [Validators.required]],
        attestazioneAlRipartitoreA:     [ this.scuola.attestazioneRipartitoreA,  [Validators.required], ],
        attestazioneAlRipartitoreA_BU:  [ this.scuola.attestazioneRipartitoreA_BU,  this.isTipoD && this.hasBackup?[Validators.required]:null,],

        clliSedeB:                      new FormControl({value: this.isTipoD?this.scuola.clliSedeA:null, disabled: true}),
        tipologiaSedeB:                 new FormControl({value: this.isTipoD?"Giunto Fittizio":null, disabled: true}),
        descrizioneSedeB:               new FormControl({value: this.isTipoD?"Giunto Fittizio":null, disabled: true}),
        attestazioneAlRipartitoreB:     new FormControl({value: this.isTipoD?this.scuola.attestazioneRipartitoreA:null, disabled: true}),
        attestazioneAlRipartitoreB_BU:  new FormControl({value: this.isTipoD?this.scuola.attestazioneRipartitoreA_BU:null, disabled: true}),
         
        clliSedeZ:                      new FormControl({value: this.pratica.centrale.clli, disabled: true}, Validators.required),
        tipologiaSedeZ:                 new FormControl({value: this.scuola.tipologiaSedeZ, disabled: false}, [Validators.required]),
        descrizioneSedeZ:               new FormControl({value: this.scuola.descrizioneSedeZ, disabled: false}, [Validators.required]),
        attestazioneAlRipartitoreZ:       [ this.scuola.attestazioneRipartitoreZ,[Validators.required], ],
        attestazioneAlRipartitoreZ_BU:    [  this.scuola.attestazioneRipartitoreZ_BU, this.isTipoD && this.hasBackup?[Validators.required]:null, ],

        numeroTotaleCoppie:     [ this.scuola.numeroTotaleCoppie, [Validators.required],],
        numeroCoppieInUso:      [ this.scuola.numeroCoppieInUso, [Validators.required]],
        fibra:                  [ this.scuola.numeroFibra, [Validators.required]],
        fibra_BU:               [ this.scuola.numeroFibra_BU, this.isTipoD && this.hasBackup?[Validators.required]:null],
        lunghezza:              [ this.scuola.lunghezza, this.isTipoD || this.isTipoB?null:[Validators.required]],
        tipoBackup:             [ this.scuola.tipoBackup?this.tipiBackup[this.getTipoBackup(this.scuola.tipoBackup)]:this.tipiBackup[this.getTipoBackup("NESSUNO")], [Validators.required]],
        flagCPEinStessoLocale:  [ this.scuola.cpeInStessoLocale?true:false],

        //   tipoBSharp:         [ this.pratica.tipoBSharp?this.pratica.tipoBSharp:false, [Validators.required]],
     //   tipologia:        [this.scuola.tipologia?this.tipologie[this.getTipologia(this.scuola.tipologia)]:null, ],
    //    diritto:          [this.scuola.diritto?this.diritti[this.getDiritto(this.scuola.diritto)]:null, !this.isTipoBFromC?[Validators.required]:null],
     //   proprietario:     [this.scuola.proprietario?this.proprietari[this.getProprietario(this.scuola.proprietario)]:null, !this.isTipoBFromC?[Validators.required]:null]
      });//
    this.identificazioneFibraFormB.get('clliSedeA').valueChanges.subscribe(value => {
      if(this.isTipoD) {
        this.identificazioneFibraFormB.get('clliSedeB').setValue(value);
      }
    });
   
    this.identificazioneFibraFormB.get('attestazioneAlRipartitoreA').valueChanges.subscribe(value => {
      if(this.isTipoD) {
        this.identificazioneFibraFormB.get('attestazioneAlRipartitoreB').setValue(value);
      }
    });
    this.identificazioneFibraFormB.get('attestazioneAlRipartitoreA_BU').valueChanges.subscribe(value => {
      if(this.isTipoD) {
        this.identificazioneFibraFormB.get('attestazioneAlRipartitoreB_BU').setValue(value);
      }
    });
      
    }else {
      this.logger.info("inizializzaFormGroups DI UNA PRATICA AC con tipo bu "+ this.scuola.tipoBackup);
      this.dettagliForm = this._formBuilder.group({
        
      });
      this.identificazioneFibraFormC = this._formBuilder.group({
        hostnameCPE:      [ this.scuola.hostnameCpe, [Validators.required]],
        localeTecnico:    [ this.scuola.localeTecnicoNome, [Validators.required]],
        piano:            [ this.scuola.localeTecnicoPiano, [Validators.required]],
        stanza:           [ this.scuola.localeTecnicoStanza, [Validators.required]],
        redattore:        [ this.pratica.datiFase3.redattore, [Validators.required]],
        verificatore:     [ this.pratica.datiFase3.verificatore, [Validators.required]],
        /* attestazioneAlRipartitoreA: [ this.scuola.attestazioneRipartitoreA,  [Validators.required], ],
        attestazioneAlRipartitoreZ: [ this.scuola.attestazioneRipartitoreZ,[Validators.required], ],
        fibra:                      [ this.scuola.numeroFibra, [Validators.required]],
        clliSedeZ:                  new FormControl({value: this.scuola.clliSedeZ?this.scuola.clliSedeZ:this.pratica.centrale.clli, disabled: true}, Validators.required),
        idPCN:                      [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.codice:null,         [Validators.required]],
        indirizzoPCN:               [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.indirizzo:null,         [Validators.required]],
        nomePCN :                   [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.nome:null,       [Validators.required]],
        latitudinePCN :             [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.latitudine:null, [Validators.required]],
        longitudinePCN:             [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.longitudine:null,[Validators.required]],
        lunghezza:          [ this.scuola.lunghezza, [Validators.required]],
        tipoBackup: [ this.scuola.tipoBackup?this.tipiBackup[this.getTipoBackup(this.scuola.tipoBackup)]:this.tipiBackup[this.getTipoBackup("NESSUNO")], [Validators.required]], */
      });
    }
   
    
    this.localizzazioniForm = this._formBuilder.group({
      indirizzoScuola:      [ this.scuola.indirizzo, [Validators.required]],
      comuneScuola:         [ this.scuola.comune.denominazione, [Validators.required]],
      latitudineScuola:     [ this.praticaFromFirestore.coordinateScuola?this.praticaFromFirestore.coordinateScuola.latitude:null, [Validators.required]],
      longitudineScuola:    [ this.praticaFromFirestore.coordinateScuola? this.praticaFromFirestore.coordinateScuola.longitude:null, [Validators.required]],
     
      indirizzoCentrale: new FormControl({value: this.pratica.centrale.indirizzo, disabled: true}, Validators.required),
      latitudineCentrale:  new FormControl({value: this.pratica.centrale?this.pratica.centrale.latitudine:null, disabled: true}, Validators.required),
      longitudineCentrale:  new FormControl({value: this.pratica.centrale?this.pratica.centrale.longitudine:null, disabled: true}, Validators.required),
      comuneCentrale:       new FormControl({value: this.pratica.centrale.comune.denominazione, disabled: true}, Validators.required),
      latitudineNodoFittizio: [this.isTipoD?this.pratica.datiFase3.latitudineNodoFittizio:null, this.isTipoD?[Validators.required]:null],
      longitudineNodoFittizio: [this.isTipoD?this.pratica.datiFase3.longitudineNodoFittizio:null, this.isTipoD?[Validators.required]:null],
    
    });
    
  }
  inizializzaSteps() {
    if(!this.isTipoAC){
      this.pagineInserisciInformazioni = [
   
        {
          label: "Dettagli",
        },
        
        {
          label: "Identificazione Fibra",
        },
        {
          label: "Localizzazioni",
        }
      ];
    }else{
      this.pagineInserisciInformazioni = [
   
        {
          label: "Dettagli",
        },
        {
          label: "Localizzazioni",
        }
      ];
    }
     
    
   
    this.activeIndex = 0;
  }

  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineInserisciInformazioni.length - 1) {
      disableNextStepButton = true;
    } else if (this.activeIndex === 1 && !this.dettagliForm.valid) {
      disableNextStepButton = true;
    }else if (this.activeIndex === 0 ) {
      //this.logger.info("CHECK NEXT STEP @ DETTAGLI "+ this.identificazioneFibraFormB.valid);
      if(!this.isTipoAC && !this.identificazioneFibraFormB.valid ){
        disableNextStepButton = true;
      }else if(this.isTipoAC && !this.identificazioneFibraFormC.valid){
        disableNextStepButton = true;
      }
      
    } else if (this.activeIndex === 2 && !this.localizzazioniForm.valid) {
      disableNextStepButton = true;
    } /* else if (this.activeIndex === 3 && !this.dettagliForm.valid) {
      disableNextStepButton = true;
    } */

    return disableNextStepButton;
  }

  changePage() {
    this.activeIndex = this.activeIndex + 1;
  }
  openMappaScuola(){
    this.logger.info("---OPENMAPPA SCUOLA----");
    this.ref = this.dialogService.open(ModificaPosizioneScuola, {
          data: {
            pratica: this.praticaFromFirestore,
            isScuola: true,
          },
          header:
            "Modifica la posizione della scuola " + this.praticaFromFirestore.cui,
          width: "70%",
          height: "95%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((changeResult) => {
          this.logger.info("CHIUDO MAPPA " + changeResult);
          const collectionRef = this.firestoreService.collection(
            this.collection_pratiche_scuola
          );
          const documentRef = collectionRef.doc(this.pratica.cui.valueOf());
          documentRef.get().subscribe((res) => {
            this.praticaFromFirestore = res.data() as PraticaFlowdy2_Firestore;
            this.localizzazioniForm
              .get("latitudineScuola")
              .setValue(this.praticaFromFirestore.coordinateScuola.latitude);
            this.localizzazioniForm
              .get("longitudineScuola")
              .setValue(this.praticaFromFirestore.coordinateScuola.longitude);
          });
        });
    /* this.ref = this.dialogService.open(DialogModificaPosizioneBando1, {
      data: {
        pratica: this.praticaFromFirestore,
        isScuola:true,
      },
      header: "Posizione della scuola",
      width: "70%",
      height: "75%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((changeResult) => {
      this.logger.info("CHIUDO MAPPA "+ changeResult);
      const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
      const documentRef   = collectionRef.doc(this.pratica.codiceInfratel.valueOf());
      documentRef.get().subscribe(res => {
        this.praticaFromFirestore =  res.data() as PraticaScuola_Firestore;
        this.localizzazioniForm.get("latitudineScuola").setValue(this.praticaFromFirestore.coordinateScuola.latitude);
        this.localizzazioniForm.get("longitudineScuola").setValue(this.praticaFromFirestore.coordinateScuola.longitude);
      });
    }); */
  }
  openMappaCentrale(){
    this.logger.info("---OPENMAPPA CENTRALE----");
    /* this.ref = this.dialogService.open(DialogModificaPosizioneBando1, {
      data: {
        pratica: this.praticaFromFirestore,
        isScuola:false,
      },
      header: "Posizione della centrale",
      width: "70%",
      height: "75%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((changeResult) => {
      this.logger.info("CHIUDO MAPPA "+ changeResult);
      const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
      const documentRef   = collectionRef.doc(this.pratica.codiceInfratel.valueOf());
      documentRef.get().subscribe(res => {
        this.praticaFromFirestore =  res.data() as PraticaScuola_Firestore;
        this.localizzazioniForm.get("latitudineCentrale").setValue(this.praticaFromFirestore.coordinateCentrale.latitude);
        this.localizzazioniForm.get("longitudineCentrale").setValue(this.praticaFromFirestore.coordinateCentrale.longitude);
      });
    }); */
  }

  openRichiediAggiornamentoDatiCentrale(){
    let centrale:Centrale = new Centrale();
    let comune:ComuneDTO = new ComuneDTO();
    comune.denominazione = this.pratica.comuneCentrale;
    centrale.clli = this.pratica.centrale.clli;
    centrale.indirizzo = this.pratica.centrale.indirizzo;
    centrale.comune = this.pratica.centrale.comune;
    centrale.latitudine = this.pratica.centrale.latitudine;
    centrale.longitudine = this.pratica.centrale.longitudine;

      this.ref = this.dialogService.open(DialogRichiediAggiornamentoCentrale, {
        data: {
          centrale: centrale,
          impresa:this.pratica.azienda.ragioneSociale,
    },
      header: 'Richiedi aggiornamento Centrale ' + this.pratica.centrale.clli.toUpperCase(),//+impresa.ragioneSociale.toUpperCase(),
      width: '50%',
      height: '70%',
      baseZIndex: 10000,
      closable:true,
      draggable:false,
    });
    this.ref.onClose.subscribe(confirmModificaCliente => {

    }); 
}
validateYearInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // Rimuove qualsiasi carattere che non sia un numero
  value = value.replace(/[^0-9]/g, '');

  // Limita il valore a 4 cifre
  if (value.length > 4) {
    value = value.slice(0, 4);
  }

  input.value = value;
  this.dettagliForm.get('annoAttivazione')?.setValue(value);
}

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let dettaglioPraticaDTO: DettaglioPraticaScuolaDTO = new DettaglioPraticaScuolaDTO();
      dettaglioPraticaDTO.id                = this.pratica.id;
      dettaglioPraticaDTO.codiceInfratel    = this.pratica.cui;
      //dettaglioPraticaDTO.backup                      = this.dettagliForm.value.backup;

      if(!this.isTipoAC){
        this.logger.info("CONFERMO TIPO B");
        this.logger.info("ANNO ATTIVAZIONE FORM "+ this.dettagliForm.value.annoAttivazione);
        dettaglioPraticaDTO.id = this.pratica.id;
        dettaglioPraticaDTO.codiceInfratel = this.pratica.cui;
        dettaglioPraticaDTO.hostnameCPE                 = this.dettagliForm.value.hostnameCPE;
        dettaglioPraticaDTO.annoAttivazione             = this.dettagliForm.value.annoAttivazione;
        dettaglioPraticaDTO.ipAddress                   = this.dettagliForm.value.ipAddress;
  
        dettaglioPraticaDTO.localeTecnico               = this.dettagliForm.value.localeTecnico;
        dettaglioPraticaDTO.piano                       = this.dettagliForm.value.piano;
        dettaglioPraticaDTO.stanza                      = this.dettagliForm.value.stanza;
        dettaglioPraticaDTO.redattore                   = this.dettagliForm.value.redattore;
        dettaglioPraticaDTO.verificatore                = this.dettagliForm.value.verificatore;
        dettaglioPraticaDTO.wifi                        = this.dettagliForm.value.wifi;
        dettaglioPraticaDTO.clliSedeA                   = this.identificazioneFibraFormB.value.clliSedeA;
        dettaglioPraticaDTO.tipologiaSedeA              =  this.identificazioneFibraFormB.value.tipologiaSedeA;
        dettaglioPraticaDTO.descrizioneSedeA            =  this.identificazioneFibraFormB.value.descrizioneSedeA;
        dettaglioPraticaDTO.attestazioneAlRipartitoreA  =  this.identificazioneFibraFormB.value.attestazioneAlRipartitoreA;
        
        dettaglioPraticaDTO.clliSedeZ                   =  this.identificazioneFibraFormB.value.clliSedeZ;
        dettaglioPraticaDTO.tipologiaSedeZ              = this.identificazioneFibraFormB.value.tipologiaSedeZ;
        dettaglioPraticaDTO.descrizioneSedeZ            = this.identificazioneFibraFormB.value.descrizioneSedeZ;
        dettaglioPraticaDTO.attestazioneAlRipartitoreZ  = this.identificazioneFibraFormB.value.attestazioneAlRipartitoreZ;

        dettaglioPraticaDTO.numeroTotaleCoppie          = this.identificazioneFibraFormB.value.numeroTotaleCoppie;
        dettaglioPraticaDTO.numeroCoppieInUso           = this.identificazioneFibraFormB.value.numeroCoppieInUso;
        dettaglioPraticaDTO.fibra                       = this.identificazioneFibraFormB.value.fibra;
        
        dettaglioPraticaDTO.tipologia                    = this.dettagliForm.value.tipologia.codice;
        dettaglioPraticaDTO.diritto                      = this.dettagliForm.value.diritto.codice;
        dettaglioPraticaDTO.proprietario                 = this.dettagliForm.value.proprietario.codice;
       // 
       // this.logger.info("LUNGHEZZA IDENTIFICAZIONE FIBRA "+ this.identificazioneFibraFormB.value.lunghezza);
        dettaglioPraticaDTO.lunghezza                    = this.dettagliForm.value.lunghezza && this.scuola.lunghezza!=this.dettagliForm.value.lunghezza?this.dettagliForm.value.lunghezza:this.identificazioneFibraFormB.value.lunghezza;
      
        this.logger.info("ANNO ATTIVAZIONE DTO "+ dettaglioPraticaDTO.annoAttivazione);

      
        // this.logger.info("LUNGHEZZA DETTAGLI "+ dettaglioPraticaDTO.lunghezza);

       /*  if(this.identificazioneFibraFormB.value.tipoBackup && this.identificazioneFibraFormB.value.tipoBackup.codice!="NESSUNO"){
          dettaglioPraticaDTO.tipoBackup      = this.identificazioneFibraFormB.value.tipoBackup.codice;
          dettaglioPraticaDTO.backup          = "true"; 
        }else{
          dettaglioPraticaDTO.tipoBackup      = "";
          dettaglioPraticaDTO.backup          = "false";
        }
        if(this.isTipoBFromC){
          dettaglioPraticaDTO.tipoBSharp  = this.identificazioneFibraFormB.value.tipoBSharp;
        } */
        if(this.isTipoD 
          && this.dettagliForm.value.lunghezzaTratta2 
          && this.dettagliForm.value.tipologiaTratta2 
          && this.dettagliForm.value.dirittoTratta2
          && this.dettagliForm.value.proprietarioTratta2){
          dettaglioPraticaDTO.lunghezzaTratta2        = this.dettagliForm.value.lunghezzaTratta2;
          dettaglioPraticaDTO.tipologiaTratta2        = this.getCodiceTipologiaCavo(this.dettagliForm.value.tipologiaTratta2.codice);
          dettaglioPraticaDTO.dirittoTratta2          = this.dettagliForm.value.dirittoTratta2.codice;
          dettaglioPraticaDTO.proprietarioTratta2     = this.dettagliForm.value.proprietarioTratta2.codice;
         
        }
        if(this.isTipoD && this.localizzazioniForm.value.latitudineNodoFittizio && this.localizzazioniForm.value.longitudineNodoFittizio){
          dettaglioPraticaDTO.latitudineNodoFittizio  = this.localizzazioniForm.value.latitudineNodoFittizio;
          dettaglioPraticaDTO.longitudineNodoFittizio = this.localizzazioniForm.value.longitudineNodoFittizio;
        }

        if(this.isTipoD && this.isColocata ){
          dettaglioPraticaDTO.cpeInStessoLocale = this.identificazioneFibraFormB.value.flagCPEinStessoLocale;
        }
        if(this.hasBackup){
          dettaglioPraticaDTO.attestazioneAlRipartitoreA_BU = this.identificazioneFibraFormB.value.attestazioneAlRipartitoreA_BU;
          dettaglioPraticaDTO.attestazioneAlRipartitoreZ_BU = this.identificazioneFibraFormB.value.attestazioneAlRipartitoreZ_BU;
          dettaglioPraticaDTO.fibra_BU                      = this.identificazioneFibraFormB.value.fibra_BU;
        }

       // }
        //
      }else{
        this.logger.info("CONFERMO TIPO AC");
       
        dettaglioPraticaDTO.hostnameCPE                 = this.identificazioneFibraFormC.value.hostnameCPE;  
        dettaglioPraticaDTO.localeTecnico               = this.identificazioneFibraFormC.value.localeTecnico;
        dettaglioPraticaDTO.piano                       = this.identificazioneFibraFormC.value.piano;
        dettaglioPraticaDTO.stanza                      = this.identificazioneFibraFormC.value.stanza;
        dettaglioPraticaDTO.redattore                   = this.identificazioneFibraFormC.value.redattore;
        dettaglioPraticaDTO.verificatore                = this.identificazioneFibraFormC.value.verificatore;
       
      /*   dettaglioPraticaDTO.attestazioneAlRipartitoreA  =  this.identificazioneFibraFormC.value.attestazioneAlRipartitoreA;
        dettaglioPraticaDTO.attestazioneAlRipartitoreZ  = this.identificazioneFibraFormC.value.attestazioneAlRipartitoreZ;
        dettaglioPraticaDTO.fibra                       = this.identificazioneFibraFormC.value.fibra;
        dettaglioPraticaDTO.clliSedeZ                   =  this.identificazioneFibraFormC.value.clliSedeZ;
        dettaglioPraticaDTO.idPCN                       = this.identificazioneFibraFormC.value.idPCN;
        dettaglioPraticaDTO.indirizzoPCN                = this.identificazioneFibraFormC.value.indirizzoPCN;
        dettaglioPraticaDTO.nomePCN                     = this.identificazioneFibraFormC.value.nomePCN;
        dettaglioPraticaDTO.latitudinePCN               = this.identificazioneFibraFormC.value.latitudinePCN;
        dettaglioPraticaDTO.longitudinePCN              = this.identificazioneFibraFormC.value.longitudinePCN;
        dettaglioPraticaDTO.lunghezza                   = this.identificazioneFibraFormC.value.lunghezza;
        if(this.identificazioneFibraFormC.value.tipoBackup && this.identificazioneFibraFormC.value.tipoBackup.codice!="NESSUNO"){
          dettaglioPraticaDTO.tipoBackup      = this.identificazioneFibraFormC.value.tipoBackup.codice;
          dettaglioPraticaDTO.backup          = "true"; 
        }else{
          dettaglioPraticaDTO.tipoBackup      = "";
          dettaglioPraticaDTO.backup          = "false";
        } */
      }
      
      

      dettaglioPraticaDTO.indirizzoScuola   = this.localizzazioniForm.value.indirizzoScuola;
      dettaglioPraticaDTO.comuneScuola      = this.localizzazioniForm.value.comuneScuola;
      dettaglioPraticaDTO.latitudineScuola  =  this.localizzazioniForm.value.latitudineScuola;
      dettaglioPraticaDTO.longitudineScuola =  this.localizzazioniForm.value.longitudineScuola;

      dettaglioPraticaDTO.indirizzoCentrale =  this.localizzazioniForm.value.indirizzoCentrale;
      dettaglioPraticaDTO.comuneCentrale    = this.localizzazioniForm.value.comuneCentrale;
      dettaglioPraticaDTO.latitudineCentrale = this.localizzazioniForm.value.latitudineCentrale;
      dettaglioPraticaDTO.longitudineCentrale =  this.localizzazioniForm.value.longitudineCentrale;
     
      this.logger.info(dettaglioPraticaDTO);

       this.praticheScuolaService
        .caricaDettagliPratica(dettaglioPraticaDTO)
        .subscribe({
          next: (v) => {},
          error: (e) => {
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di AGGIORNAMENTO DELLE INFORMAZIONI FASE 3 della pratica",
            });
            this.dialogRef.close({ success: false });
          },
          complete: () => {
            this.dialogRef.close({ success: true });
             this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "INFORMAZIONI FASE 3 della pratica aggiornate con successo",
              }); 
          },
        }); 
    }
  }
}